import CacheBase2 from '../../../services/engines/CacheBase2';

const _name = 'Pnl3UnmatchedCache';

// Mirrors Pnl3OrderStates.cs (BE) — stateId, not a string state, per the BE DTO.
const FILLED_STATE_ID = 999;

/**
 * Holds unmatched (open) buy orders across all assets, flat, keyed by each order's
 * own rk. Shared across every open Pnl3Widget instance, same pattern as Pnl3Cache.
 */
class Pnl3UnmatchedCache extends CacheBase2 {
    initialize() {
        this._name = _name;
    }

    /**
     * Filters out Filled orders — mirrors Pnl3OrderContainer.GetUnmatched() (BE), which
     * also excludes State==Filled. An order can arrive here via a mutation event
     * already Filled (fully matched); it must not show as still-open.
     * @param {number|string} sid
     * @returns {object[]}
     */
    getBySid = (sid) => {
        try {
            return this._items.filter((o) => String(o.sid) === String(sid) && o.stateId !== FILLED_STATE_ID);
        } catch (error) {
            this.logError('getBySid', error.message);
            return [];
        }
    };

    /**
     * Replaces every entry for one sid with a fresh set — needed because a row can
     * disappear from "unmatched" (fully matched) between fetches, which addOrUpdate
     * alone would never remove.
     * @param {number|string} sid
     * @param {object[]} items
     */
    replaceForSid = (sid, items) => {
        try {
            this._items = this._items.filter((o) => String(o.sid) !== String(sid));
            this.addOrUpdate(items);
        } catch (error) {
            this.logError('replaceForSid', error.message);
        }
    };
}

const pnl3UnmatchedCache = new Pnl3UnmatchedCache();
export default pnl3UnmatchedCache;
